import { cn } from '@/lib/utils'
import logo from '@/assets/green-line-logo.png'

/**
 * The Green Line Ingredients logo lockup (leaf mark + wordmark), self-hosted
 * so CSP `img-src 'self'` stays intact. Rendered at h-8 from an 800px-wide
 * source — crisp on retina everywhere the wordmark appears (sidebar, drawer,
 * auth pages, error/404 screens).
 */
export function Wordmark({ className }: { className?: string }) {
  return (
    <img
      src={logo}
      alt="Green Line Ingredients"
      className={cn('h-8 w-auto select-none', className)}
      draggable={false}
    />
  )
}
